import { useTranslation } from 'react-i18next'

import ImageComponent from '#app/components/common/image-component'
import PlentyBody from '#app/components/typography/plenty-body'
import PlentyHeading from '#app/components/typography/plenty-heading'
import { getFirstNonInstagramOrCustomMedia } from '#app/utils/media-utils'
import { cn } from '#app/utils/misc'
import { type PlentyLineItem } from '#types/cart'
import { getVariantSize } from '../../utils'
import { BagPriceTag } from './bag-item-price-tag'

interface ProductBagCardProps {
	plentyLineItem: PlentyLineItem
}

const ProductBagCard = ({ plentyLineItem }: ProductBagCardProps) => {
	let { t } = useTranslation('common')
	return (
		<>
			<div className="my-4">
				<div className="flex items-start space-x-4">
					<ImageComponent
						size="thumbnail"
						src={getFirstNonInstagramOrCustomMedia(
							plentyLineItem.variant.images,
						)}
						alt="thumbnail-product"
						className="w-[100px] rounded-lg object-cover transition-transform hover:scale-105"
					/>

					<div className="flex-grow">
						{/* Brand and name */}

						<div className="space-y-1 group-hover/clickable:underline">
							<PlentyHeading as="h7">
								{
									plentyLineItem.variant.attributes?.find(
										it => it.name === 'brand',
									)?.value
								}
							</PlentyHeading>
						</div>
						<div>
							<PlentyBody size="md">{plentyLineItem.name.en}</PlentyBody>
						</div>

						{/* Product */}

						<BagPriceTag price={plentyLineItem.price} />

						{/* Colour and size */}
						<div className="flex justify-between">
							<PlentyBody className="text-beige-100" size="sm">
								{t('colour_header') + ':'}
							</PlentyBody>
							<PlentyBody className="text-beige-100" size="sm">
								{
									plentyLineItem.variant.attributes?.find(
										it => it.name === 'color',
									)?.value.en
								}
							</PlentyBody>
						</div>
						{/* Colour and Size values */}
						<div className="flex justify-between">
							<PlentyBody className="text-beige-100" size="sm">
								{t('size') + ':'}
							</PlentyBody>
							<div className="flex flex-row space-x-2">
								<PlentyBody className="text-beige-100" size="sm">
									{getVariantSize(plentyLineItem.variant)}
								</PlentyBody>
								<PlentyBody
									className={cn(
										'hidden text-red',
										// plentyLineItem.stock < 3 ? 'flex' : 'hidden',
									)}
									size="sm"
								>
									{t('shopping_bag:few_left_label')}
								</PlentyBody>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default ProductBagCard
